import PdfToolsPanel from '@/components/admin/PdfToolsPanel';

export default function AdminPdfToolsPage() {
  return <PdfToolsPanel />;
}
